module.exports = __webpack_public_path__ + "img/OPP sisters stepping 1989.74d1f6df.png";